"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/ja");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "\u4EE3\u66FF\u30C6\u30AD\u30B9\u30C8\uFF1A"
  },
  announcement_list_da155734: {
    message: "\u30A2\u30CA\u30A6\u30F3\u30B9 \u30EA\u30B9\u30C8"
  },
  announcements_a4b8ed4a: {
    message: "\u30A2\u30CA\u30A6\u30F3\u30B9"
  },
  assignments_1e02582c: {
    message: "\u8AB2\u984C"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "\u80CC\u666F\u8272\u3001\u62BC\u3057\u3066\u9078\u629E"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "\u30D5\u30A1\u30A4\u30EB\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B"
  },
  cancel_image_upload_2c771950: {
    message: "\u753B\u50CF\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3059\u308B"
  },
  cc_attribution_f6de631f: {
    message: "CC \u5C5E\u6027"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC \u5C5E\u6027 \u6D3E\u751F\u7269\u306A\u3057"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC \u5C5E\u6027 \u975E\u55B6\u5229"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC \u5C5E\u6027 \u975E\u55B6\u5229 \u6D3E\u751F\u7269\u306A\u3057"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC \u5C5E\u6027 \u975E\u55B6\u5229 \u5E73\u7B49\u5206\u62C5"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC \u5C5E\u6027 \u5E73\u7B49\u5206\u62C5"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "\u753B\u50CF\u304C\u88C5\u98FE\u304B\u3069\u3046\u304B\u3092\u78BA\u8A8D\u3059\u308B"
  },
  choose_usage_rights_33683854: {
    message: "\u4F7F\u7528\u6A29\u3092\u9078\u629E..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "\u30D5\u30A1\u30A4\u30EB\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u305D\u306E\u30D5\u30A1\u30A4\u30EB\u306B\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9 \u30EA\u30F3\u30AF\u3092\u633F\u5165\u3057\u307E\u3059\u3002"
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "\u753B\u50CF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u305D\u306E\u753B\u50CF\u3092\u30DA\u30FC\u30B8\u306B\u57CB\u3081\u8FBC\u307F\u307E\u3059\u3002"
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "\u30DA\u30FC\u30B8\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u305D\u306E\u30DA\u30FC\u30B8\u306B\u30EA\u30F3\u30AF\u3092\u633F\u5165\u3057\u307E\u3059\u3002"
  },
  click_to_embed_image_33107dd8: {
    message: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u753B\u50CF\u3092\u57CB\u3081\u8FBC\u3080"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066 { imageName } \u3092\u57CB\u3081\u8FBC\u3080"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3001\u30A8\u30C7\u30A3\u30BF\u306B\u30EA\u30F3\u30AF\u304C\u633F\u5165\u3055\u308C\u307E\u3059\u3002"
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "\u30AF\u30EA\u30C3\u30AF\u3059\u308B\u3068\u3053\u306E\u30A2\u30A4\u30C6\u30E0\u3078\u306E\u30EA\u30F3\u30AF\u304C\u633F\u5165\u3055\u308C\u307E\u3059\u3002"
  },
  close_flickr_form_b32e600a: {
    message: "Flickr \u30D5\u30A9\u30FC\u30E0\u3092\u9589\u3058\u308B"
  },
  collaborations_5c56c15f: {
    message: "\u5171\u540C\u4F5C\u696D"
  },
  copyright_holder_66ee111: {
    message: "\u8457\u4F5C\u6A29\u4FDD\u6709\u8005:"
  },
  course_navigation_dd035109: {
    message: "\u30B3\u30FC\u30B9 \u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3"
  },
  creative_commons_license_725584ae: {
    message: "\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6 \u30B3\u30E2\u30F3\u30BA \u30E9\u30A4\u30BB\u30F3\u30B9:"
  },
  decorative_image_fde98579: {
    message: "\u88C5\u98FE\u306E\u753B\u50CF"
  },
  discussions_a5f96392: {
    message: "\u30C7\u30A3\u30B9\u30AB\u30C3\u30B7\u30E7\u30F3"
  },
  discussions_index_6c36ced: {
    message: "\u30C7\u30A3\u30B9\u30AB\u30C3\u30B7\u30E7\u30F3\u306E\u30A4\u30F3\u30C7\u30C3\u30AF\u30B9"
  },
  embed_image_1080badc: {
    message: "\u753B\u50CF\u306E\u57CB\u3081\u8FBC\u307F"
  },
  enter_search_terms_e397b1f0: {
    message: "\u691C\u7D22\u8A9E\u3092\u5165\u529B"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "\u3053\u306E\u753B\u50CF\u306E\u4EE3\u66FF\u30C6\u30AD\u30B9\u30C8\u3092\u5165\u529B\u3059\u308B"
  },
  file_upload_form_4aaad554: {
    message: "\u30D5\u30A1\u30A4\u30EB\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u30D5\u30A9\u30FC\u30E0"
  },
  files_c300e900: {
    message: "\u30D5\u30A1\u30A4\u30EB"
  },
  files_index_af7c662b: {
    message: "\u30D5\u30A1\u30A4\u30EB\u306E\u30A4\u30F3\u30C7\u30C3\u30AF\u30B9"
  },
  folder_705fd2d7: {
    message: "\u30D5\u30A9\u30EB\u30C0"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "\u30D5\u30A9\u30F3\u30C8 \u30B5\u30A4\u30BA\u3001\u62BC\u3057\u3066\u9078\u629E"
  },
  formatting_press_down_to_select_df728c30: {
    message: "\u66F8\u5F0F\u8A2D\u5B9A\u3001\u62BC\u3057\u3066\u9078\u629E"
  },
  grades_a61eba0a: {
    message: "\u6210\u7E3E"
  },
  group_navigation_99f191a: {
    message: "\u30B0\u30EB\u30FC\u30D7 \u30CA\u30D3\u30B2\u30FC\u30B7\u30E7\u30F3"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "\u3053\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u4F7F\u7528\u3059\u308B\u6A29\u9650\u3092\u53D6\u5F97\u3057\u3066\u3044\u307E\u3059\u3002"
  },
  i_hold_the_copyright_71ee91b1: {
    message: "\u8457\u4F5C\u6A29\u3092\u4FDD\u6709\u3057\u3066\u3044\u307E\u3059"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "\u4ECA\u3059\u3050\u4F7F\u7528\u6A29\u3092\u9078\u629E\u3057\u306A\u3044\u3068\u3001\u3053\u306E\u30D5\u30A1\u30A4\u30EB\u306F\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u5F8C\u306B\u516C\u958B\u3055\u308C\u307E\u305B\u3093\u3002"
  },
  image_upload_form_7b74079a: {
    message: "\u753B\u50CF\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u30D5\u30A9\u30FC\u30E0"
  },
  images_7ce26570: {
    message: "\u753B\u50CF"
  },
  insert_equella_links_49a8dacd: {
    message: "Equella \u30EA\u30F3\u30AF\u3092\u633F\u5165\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  insert_link_6dc23cae: {
    message: "\u30EA\u30F3\u30AF\u306E\u633F\u5165"
  },
  insert_math_equation_57c6e767: {
    message: "\u6570\u5B66\u6570\u5F0F\u3092\u633F\u5165"
  },
  link_7262adec: {
    message: "\u30EA\u30F3\u30AF"
  },
  link_to_a_new_page_6c4ad034: {
    message: "\u65B0\u3057\u3044\u30DA\u30FC\u30B8\u3078\u306E\u30EA\u30F3\u30AF"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "\u30B3\u30FC\u30B9\u5185\u306E\u4ED6\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u30EA\u30F3\u30AF\u3057\u307E\u3059\u3002"
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "\u30B0\u30EB\u30FC\u30D7\u5185\u306E\u4ED6\u306E\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u30EA\u30F3\u30AF\u3057\u307E\u3059\u3002"
  },
  link_to_url_52dd935c: {
    message: "URL\u3078\u306E\u30EA\u30F3\u30AF "
  },
  links_14b70841: {
    message: "\u30EA\u30F3\u30AF"
  },
  load_more_results_460f49a9: {
    message: "\u3055\u3089\u306B\u7D50\u679C\u3092\u30ED\u30FC\u30C9"
  },
  loading_25990131: {
    message: "\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059..."
  },
  loading_failed_b3524381: {
    message: "\u8AAD\u307F\u8FBC\u307F\u306B\u5931\u6557\u3057\u307E\u3057\u305F..."
  },
  loading_folders_8d4d5d5a: {
    message: "\u30D5\u30A9\u30EB\u30C0\u3092\u8AAD\u307F\u8FBC\u307F\u4E2D..."
  },
  modules_c4325335: {
    message: "\u30E2\u30B8\u30E5\u30FC\u30EB"
  },
  no_results_940393cf: {
    message: "\u7D50\u679C\u304C\u3042\u308A\u307E\u305B\u3093\u3002"
  },
  pages_e5414c2c: {
    message: "\u30DA\u30FC\u30B8"
  },
  people_b4ebb13c: {
    message: "\u30E1\u30F3\u30D0\u30FC"
  },
  quizzes_7e598f57: {
    message: "\u30AF\u30A4\u30BA"
  },
  record_upload_media_5fdce166: {
    message: "\u30E1\u30C7\u30A3\u30A2\u306E\u8A18\u9332/\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "\u30EA\u30C3\u30C1\u30C6\u30AD\u30B9\u30C8\u30A8\u30EA\u30A2\u3002\u30D8\u30EB\u30D7\u3078\u306F\u3001ALT+F8\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  search_280d00bd: {
    message: "\u691C\u7D22"
  },
  search_flickr_6884b518: {
    message: "Flickr \u3092\u691C\u7D22"
  },
  select_a_file_53ba40ac: {
    message: "\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3059\u308B\u30D5\u30A9\u30EB\u30C0\u3092\u9078\u629E"
  },
  syllabus_f191f65b: {
    message: "\u30B7\u30E9\u30D0\u30B9"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "\u30C6\u30AD\u30B9\u30C8\u8272\u3001\u62BC\u3057\u3066\u9078\u629E"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "\u3053\u306E\u8CC7\u6599\u306F\u30D1\u30D6\u30EA\u30C3\u30AF \u30C9\u30E1\u30A4\u30F3\u3067\u3059"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "\u3053\u306E\u8CC7\u6599\u306F\u30AF\u30EA\u30A8\u30A4\u30C6\u30A3\u30D6 \u30B3\u30E2\u30F3\u30BA \u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u5BFE\u8C61\u3068\u306A\u308A\u307E\u3059"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "\u3053\u306E\u8CC7\u6599\u306F\u516C\u6B63\u4F7F\u7528\u306E\u4F8B\u5916\u306B\u8A72\u5F53\u3057\u307E\u3059"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "\u3053\u306E\u5B50\u82AF\u306F\u3001\u30D5\u30A1\u30A4\u30EB\u4FDD\u5B58\u306E\u5272\u308A\u5F53\u3066\u3092\u8D85\u3048\u3066\u3044\u307E\u3059\u3002\u30B7\u30B9\u30C6\u30E0\u30A2\u30C9\u30DF\u30CB\u30B9\u30C8\u30EC\u30FC\u30BF\u306B\u5831\u544A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
  },
  upload_8b403d05: {
    message: "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9"
  },
  upload_a_new_file_96e6d4ff: {
    message: "\u65B0\u3057\u3044\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3059\u308B"
  },
  upload_a_new_image_890df275: {
    message: "\u65B0\u3057\u3044\u753B\u50CF\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3059\u308B"
  },
  usage_right_ff96f3e2: {
    message: "\u4F7F\u7528\u6A29:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "\u65B0\u3057\u3044\u30DA\u30FC\u30B8\u306E\u540D\u524D\u306F\u4F55\u306B\u3057\u307E\u3059\u304B?"
  },
  wiki_home_9cd54d0: {
    message: "Wiki \u30DB\u30FC\u30E0"
  }
};

_formatMessage.default.addLocale({
  ja: locale
});